module.exports = __webpack_public_path__ + "img/team_1.d371ce76.png";